import React from "react";
import { MenuItem, TextField, Typography } from "@material-ui/core";
import useTranslatedValue from "../../../../hooks/useTranslatedValue";
import useAnswerQuestion from "../../hooks/useAnswerQuestion";
import useQuestionStyles from "./questionStyles";

const Z_INDEX = 1300;
const OFFSET_MARGIN_TOP = 8;

const DropDownQuestion = ({ question, isDisabled, followUpUUID }) => {
    const classes = useQuestionStyles();
    const getTranslatedValue = useTranslatedValue();
    const answerQuestion = useAnswerQuestion();

    return (
        <>
            <Typography variant="body1" className={classes.questionText}>
                {question.mandatory && <span className={classes.mandatory}>*</span>}
                {getTranslatedValue(question.questionText)}
            </Typography>
            <TextField
                select
                fullWidth
                name={question.name}
                value={question.value ?? ""}
                variant="outlined"
                onChange={(e) => answerQuestion(e.target.value, question, followUpUUID)}
                disabled={isDisabled || question.isDisabled}
                required={question.mandatory}
                label={getTranslatedValue(question.tooltip)}
                InputLabelProps={{
                    className: classes.inputLabel,
                }}
                SelectProps={{
                    MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: { vertical: "bottom", horizontal: "left" },
                        transformOrigin: { vertical: "top", horizontal: "left" },
                        PaperProps: { style: { marginTop: OFFSET_MARGIN_TOP, zIndex: Z_INDEX } },
                    },
                }}
                InputProps={{
                    className: classes.input,
                }}>
                {question.props?.allowedValues?.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {getTranslatedValue(option)}
                    </MenuItem>
                ))}
            </TextField>
        </>
    );
};

export default DropDownQuestion;
